import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import './App.css';
import InfoPage from './pages/infoPage.jsx';
import VerifyBank from './pages/verifyBank.jsx';
import OAuthCallback from './pages/oauthCallback.jsx';
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';
import { ThemeProvider } from '@emotion/react';
import { defaultTheme, themes } from './globalStyleds';
import store from './configureStore.js';
import { Provider, useSelector } from 'react-redux';
import { datadogRum } from '@datadog/browser-rum';
import SafeToClosePage from './pages/safeToClosePage.jsx';
import {detectAndSetLanguageFromURL} from "./i18n/i18n.js"; // Import i18n configuration

// Detect and set language from URL parameter on app initialization
detectAndSetLanguageFromURL();

const root = createRoot(document.getElementById('root'));

if (import.meta.env.VITE_APP_DATADOG_APPLICATION_ID) {
  datadogRum.init({
    applicationId: import.meta.env.VITE_APP_DATADOG_APPLICATION_ID,
    clientToken: import.meta.env.VITE_APP_DATADOG_CLIENT_TOKEN,
    site: import.meta.env.VITE_APP_DATADOG_SITE,
    service: import.meta.env.VITE_APP_DATADOG_SERVICE,
    env: import.meta.env.VITE_APP_DATADOG_ENV,
    version: import.meta.env.VITE_APP_DATADOG_VERSION,
    sampleRate: 100,
    trackInteractions: true,
  });
}

export const AppWithTheme = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const themeFromURL = queryParams.get('theme');

  const themeFromStore = useSelector((state) => state.app.theme);

  const themeKey = themeFromURL || themeFromStore || defaultTheme;
  const theme = themes[themeKey] || themes[defaultTheme];

  return (
    <ThemeProvider theme={theme}>
        <Routes>
          <Route path="/bank-select" element={<VerifyBank />} />
          {import.meta.env.VITE_APP_INFO_ENABLED === 'true' && <Route path="/info" element={<InfoPage />} />}
          <Route path="/safe-to-close" element={<SafeToClosePage />} />
          <Route path="/oauth-callback" element={<OAuthCallback />} />
        </Routes>
    </ThemeProvider>
  );
};

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <AppWithTheme />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>,
);
